<template>
    <div v-if="platoons.length > 0 && sections.length > 0" class="container-fluid challenge-management">
        <div class="title-header">
            <h3 class="text-center challenge-header">Challenge Management</h3>
            <div class="d-flex justify-content-end mb-2">
                <button class="btn btn-primary me-2" @click="createNewChallenge">Create New Challenge</button>
            </div>
        </div>
        <!-- Add your challenge management content here -->
        <div class="dashboard">
            <div class="card-body" style="padding-top: 0rem;padding-left: 0 !important;">
                <div class="table-responsive">
                    <el-table ref="dataTable" :data="challengeRecords" style="width: 100%"
                       @sort-change="sortColumn">
                        <el-table-column prop="id" label="Id" sortable="custom" width="75">
                            <template #default="scope">
                                <span v-if="scope.row">{{ scope.row.id }} </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" label="Title" width="500" sortable="custom">
                            <template #default="scope">
                                <el-tooltip effect="customized" v-if="scope.row" placement="top-start"
                                    :content="scope.row.description" :open-delay="1000">
                                    <span>{{ scope.row.title }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="duration" label="Duration" width="150" class-name="pe-2"
                            sortable="custom">
                            <template #default="scope">
                                <span v-if="scope.row">{{ scope.row.duration }} Minutes</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platoonId" label="Platoon" width="150" class-name="pe-2"
                            sortable="custom">
                            <template #default="scope">
                                <span v-if="scope.row">{{ getPlatoonName(scope.row.platoon_id) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sectionId" label="Section" width="150" class-name="pe-2"
                            sortable="custom">
                            <template #default="scope">
                                <span v-if="scope.row">{{ getSectionName(scope.row.section_id) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="communityGrpId" label="Community Id" width="150" class-name="pe-2"
                            sortable="custom">
                            <template #default="scope">
                                <span v-if="scope.row">{{ scope.row.community_grp_id }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="200" class-name="pe-2" sortable="custom">
                            <template #default="scope">
                                <span v-if="scope.row">{{ scope.row.status }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="startTime" label="Start Time" width="175" class-name="pe-2"
                            sortable="custom">
                            <template #default="scope">
                                <span v-if="scope.row">{{ formatDob(scope.row.start_time) }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="endTime" label="End Time" width="200" class-name="pe-2"
                            sortable="custom">
                            <template #default="scope">
                                <span v-if="scope.row">{{ formatDob(scope.row.end_time) }}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Actions" width="500" class-name="pe-2" header-align="center">
                            <template #default="scope">
                                <div class="d-flex justify-content-center">
                                    <button class="btn btn-info" @click="viewChallengeDetails(scope.row)">View</button>
                                    <button class="btn btn-warning" style="margin-left: 0.5rem !important;"
                                        @click="deleteChallenge(scope.row.id)">Delete</button>
                                    <button class="button start-button" @click="reStartChallenge(scope.row)">
                                        <i class="fas fa-play"></i>
                                        Re-Start
                                    </button>  
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <div id="createChallengeModal"> <CreateChallenge /></div>
        <div id="displayChallengeDetails">
            <modal id="addChallengeModal"  v-model:show="displayChallengeDetails"
                :modalContentClasses="'challenge-details-model'"
                :show-close="true">
                    <template #header v-if="selectedChallenge">
                        <h4 class="modal-title"> {{ selectedChallenge.title }} - {{ selectedChallenge.status }}</h4>
                    </template>

                    <ChallengeResults v-if="challengeUsers.length > 0" :users="challengeUsers" />
            </modal>    
        </div>
    </div>
</template>

<script>
import Utils from "@/helpers/utils";
import store from "@/store";
import Modal from "@/shared/Modal.vue";
import CreateChallenge from './CreateChallenge.vue';
import ChallengeResults from "./ChallengeResults.vue";


export default {
    name: 'ChallengeManagement',
    components: {
        CreateChallenge,
        ChallengeResults,
        Modal,
    },
    mounted() {
        this.fetchExistingChallenges();   
        this.fetchPlatoons();
        this.fetchSections();
    },
    data() {
        return {
            challengeRecords: [],
            page: -1,
            pageSize: 10,
            sort: 'createdAt',
            order: 'desc',
            selectedSection: -1,
            searchText: '',
            selectedPlatoon: -1,
            addChallenge: false,
            platoons: [],
            sections: [],
            displayChallengeDetails: false,
            challengeUsers: [],
            selectedChallengeTitle: '',
            selectedChallenge: null,
        };
    },
    methods: {
        createNewChallenge() {
            this.addChallenge = true;
        },
        viewChallengeDetails(challenge) {
            console.log('Viewing a challenge:', challenge);
            this.displayChallengeDetails = true;
            this.selectedChallenge = challenge;
            store.dispatch("challenge/fetchResults", {
                challenge_id: challenge.id,
            })
            .then((data) => {
                this.challengeUsers = data.data;
            }).catch((err) => {
                this.$snackbar.add({
                    type: "error",
                    text: "Failed to fetch challenge details." + err,
                });
            });  
        },
        deleteChallenge(challenge_id) {
            console.log('Deleting a challenge with ID:', challenge_id);
            store.dispatch("challenge/delete", {
                challenge_id: challenge_id,
            })
            .then((data) => {
                this.fetchExistingChallenges(); // Refresh the list after deletion                
                this.$snackbar.add({
                    type: "success",
                    text: data.data,
                });
            }).catch((err) => {
                this.$snackbar.add({
                    type: "error",
                    text: "Failed to delete challenge." + err,
                });
            });
        },
        closeModal() {
            this.addChallenge = false;
            this.displayChallengeDetails = false;
            this.challengeUsers = [];
        },
        sortColumn(column) {
            console.log('Sorting column:', column);
        },
        fetchExistingChallenges() {
            store.dispatch("challenge/list", {
                page: this.page,
                page_size: this.pageSize,
                sort: this.sort,
                order: this.order,
                section_id: this.selectedSection || -1,
                search_term: this.searchText,
                platoon_id: this.selectedPlatoon || -1,
            })
            .then((data) => {
                // const { count, rows } = data.data;
                // this.count = count;
                this.challengeRecords = data.data;
            }).catch((err) => {
                console.error("Error fetching challenge list: ", err);
                this.$snackbar.add({
                  type: "error",
                  text: "Failed to fetch challenge list.",
                });
            });
        },
        fetchPlatoons() {
            store.dispatch("list/getPlatoons", { sort: "name", order: "asc",  platoon_id: -1  })
            .then((res) => {
                this.platoons = res.data;
            }).catch((err) => {
                console.error("Error fetching platoons: ", err);
            });
        },
        getPlatoonName(platoonId) {
            const platoon = this.platoons.find(platoon => platoon.platoon_id === platoonId);
            return platoon ? platoon.name : '--';
        },
        getSectionName(sectionId) {
            const section = this.sections.find(section => section.section_id === sectionId);
            return section ? section.name : '--';
        },
        fetchSections() {
            this.$store.dispatch("list/getSections", { sort: "name", order: "asc" })
                .then((res) => {
                    this.sections = res.data;
                }).catch((err) => {
                    console.error("Error fetching sections: ", err);
                });
        },
        formatDob(ts) {
            return Utils.formatTimeStampToAmPM(ts);
        },
        startChallenge(selectedChallenge) {
            const routeData = this.$router.resolve({name: 'LiveChallengeDashBoard', query: {challengeId: selectedChallenge.id}});
            window.open(routeData.href, '_blank');
        },
        reStartChallenge(selectedChallenge) {
            console.log('Re-starting challenge:', selectedChallenge);
            // start the challenge
            store.dispatch("challenge/reStartChallenge", {
                challenge_id: selectedChallenge.id,
            })
            .then((data) => {
                let newChallenge = data.data;
                this.fetchExistingChallenges(); // Refresh the list after re-starting
                this.startChallenge(newChallenge);
            }).catch((err) => {
                this.$snackbar.add({
                    type: "error",
                    text: "Failed to restart the challenge." + err,
                });
            }); 
        },
    }
};
</script>

<style scoped>
.challenge-management {
    width: 98%;
    margin-left: 1rem;
    border-radius: 0.25rem;
    background-color: #1f2628 !important;
}

.challenge-header {
    padding-top: 1rem;
}

.start-button {
    height: 2.25rem;
    margin-left: 0.5rem;
    background-color: #28a745;
    color: white;
    font-size: 0.9rem;
    font-weight: 500;
    padding: 0.5rem 0.75rem;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.start-button:hover {
      background-color: #218838;
      box-shadow: 0 6px 20px rgba(40, 167, 69, 0.5);
      transform: scale(1.05);
}

.start-button:active {
      transform: scale(0.95);
}

.start-button i {
      font-size: 0.85rem;
}

.modal-content {
    min-width: 82rem !important;
}
</style>
